"use strict";

import angular from "angular";

angular.module("nucont.privacyPolicy", ["nucont.shared"]);
require("./privacy-policy.routes");
